export const WAITING_TIME_IN_MS = 2000;
